<template>
  <el-dialog title="通过并设置目录" :visible.sync="dialogVisible" width="600px" :before-close="handleBeforeClose">
    <el-form :model="formData" :rules="formRules" ref="formData" label-width="100px" class="demo-ruleForm">
      <el-form-item label="选择学段" prop="sectionId">
        <el-select v-model="formData.sectionId" placeholder="请选择" @change="sectionChange" size="small">
          <el-option v-for="item in sectionData" :key="'section_'+item.id" :label="item.label" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="选择学科" prop="subjectId">
        <el-select v-model="formData.subjectId" placeholder="请选择" filterable @change="subjectChange" size="small">
          <el-option v-for="item in subjectData" :key="'subject_'+item.id" :label="item.label" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="选择目录" prop="catalog">
        <el-cascader v-model="formData.catalog" :options="catalogData" :props="{ value:'id',checkStrictly: true }" clearable size="small"
                     @change="catalogChange" v-if="catalogisShow"></el-cascader>
      </el-form-item>
      <el-form-item label="资源类别" prop="resourceTypeId">
        <el-select v-model="formData.resourceTypeId" placeholder="请选择" filterable size="small">
          <el-option v-for="item in resourceData" :key="item.code" :label="item.name" :value="item.code"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="视频名称" prop="resourceName">
        <el-input v-model="formData.resourceName" size="small "></el-input>
      </el-form-item>
      <el-form-item label="年级" prop="gradeId">
        <el-select v-model="formData.gradeId" placeholder="请选择" filterable size="small" disabled>
          <el-option v-for="item in gradeData" :key="'grade_'+item.node" :label="item.text" :value="item.node"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="submit">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
      type: "",
      catalogisShow: false, //Cascader回显有问题，销毁重建解决
      formData: {
        sectionId: "", //学段
        subjectId: "", //学科
        catalog: [], //目录
        versionId: "", //版本
        volumeId: "", //册次
        firstChapterId: "", //章节1
        secondChapterId: "",
        thirdChapterId: "",
        fourthChapterId: "",
        resourceTypeId: "", //资源类别
        resourceName: "", //视频名称
        resourceId: "",
        gradeId: "",
        fileId: "",
        fileSize: "",
        fileUrl: "",
      },
      formRules: {
        sectionId: [
          { required: true, message: "请选择学段", trigger: "change" },
        ],
        subjectId: [
          { required: true, message: "请选择学科", trigger: "change" },
        ],
        catalog: [
          {
            required: true,
            trigger: "change",
            validator: (rule, value, callback) => {
              if (value && value.length >= 2) {
                callback();
              } else {
                callback(new Error("请至少选至年级"));
              }
            },
          },
        ],
        resourceTypeId: [
          { required: true, message: "请选择资源类别", trigger: "change" },
        ],
        gradeId: [
          { required: true, message: "请通过目录选择年级", trigger: "change" },
        ],
        resourceName: [
          { required: true, message: "请输入视频名称", trigger: "blur" },
        ],
      },
      sectionData: [],
      subjectData: [],
      catalogData: [],
      resourceData: [],
      gradeData: [],
    };
  },
  created() {
    this.sectionData = JSON.parse(window.sessionStorage.getItem("sectionData"));
    this.getResource();
  },
  mounted() {
    //修改名称无效
  },
  methods: {
    init(data, type) {
      console.log(data);
      // type:add通过，edit变更目录
      this.dialogVisible = true;
      this.catalogisShow = false;
      this.$nextTick(() => {
        this.type = type;
        if (type == "edit") {
          this.formData.sectionId = data.sectionId;
          this.sectionChange(data.sectionId);
          this.formData.subjectId = data.subjectId;
          this.subjectChange(data.subjectId);
          this.formData.versionId = data.versionId;
          this.formData.volumeId = data.volumeId;
          this.formData.firstChapterId = data.firstChapterId;
          this.formData.secondChapterId = data.secondChapterId;
          this.formData.thirdChapterId = data.thirdChapterId;
          this.formData.fourthChapterId = data.fourthChapterId;
          this.formData.resourceTypeId = data.resourceTypeId;
          this.formData.gradeId = data.gradeId;
          this.getGrade();

          data.versionId ? this.formData.catalog.push(data.versionId) : "";
          data.volumeId ? this.formData.catalog.push(data.volumeId) : "";
          data.firstChapterId
            ? this.formData.catalog.push(data.firstChapterId)
            : "";
          data.secondChapterId
            ? this.formData.catalog.push(data.secondChapterId)
            : "";
          data.thirdChapterId
            ? this.formData.catalog.push(data.thirdChapterId)
            : "";
          data.fourthChapterId
            ? this.formData.catalog.push(data.fourthChapterId)
            : "";
        }
        this.formData.resourceId = data.resourceId;
        this.formData.resourceName = data.resourceName;
        this.formData.fileUrl = data.fileUrl;
        this.formData.coverUrl = data.coverUrl;
        this.formData.fileId = data.fileId;
        this.formData.fileSize = data.fileSize;
        this.catalogisShow = true;
      });
    },
    handleBeforeClose() {
      this.formDataReload();
      this.dialogVisible = false;
    },
    formDataReload() {
      this.$refs.formData.resetFields();
      //   this.formData = this.$options.data().formData;
    },
    submit() {
      this.$refs.formData.validate((valid) => {
        if (valid) {
          let url =
            this.type == "add"
              ? "/server/third/resource/approval/pass"
              : "/server/third/resource/approval/update";
          this.$ajax
            .post(url, this.formData, {
              headers: {
                "Content-Type": "application/json",
              },
            })
            .then((res) => {
              this.$message({
                message: "已通过",
                type: "success",
              });
              this.formDataReload();
              this.dialogVisible = false;
              this.$emit("search");
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    getResource() {
      this.$ajax.post("/common/load/resource/type").then((res) => {
        this.resourceData = res;
      });
    },
    // 获取年级
    getGrade() {
      this.$ajax
        .post("/common/catalog/load/grade", {
          sectionId: this.formData.sectionId,
        })
        .then((res) => {
          this.gradeData = res;
        });
    },
    sectionChange(val) {
      this.formData.subjectId = "";
      this.formData.catalog = [];
      this.formData.gradeId = "";
      this.catalogChange();
      this.catalogData = [];
      this.gradeData = [];
      this.getGrade();
      this.subjectData = this.sectionData.find(
        (item) => item.id == val
      ).children;
    },
    subjectChange(val) {
      this.formData.catalog = [];
      this.formData.gradeId = "";
      this.catalogChange();
      this.catalogData = this.subjectData.find(
        (item) => item.id == val
      ).children;
    },
    catalogChange(val) {
      console.log(val);
      // 至少选至年级：formData.catalog长度至少为2
      if (!(val && val.length >= 2)) return;
      this.formData.gradeId = "";
      let key = [
        "versionId",
        "volumeId",
        "firstChapterId",
        "secondChapterId",
        "thirdChapterId",
        "fourthChapterId",
      ];
      key.forEach((item, index) => (this.formData[item] = "")); // 重置formData中的key属性
      val.forEach((item, index) => (this.formData[key[index]] = item)); // 赋值formData中的key属性
      console.log(this.catalogData);
      //版本信息
      let catalogDataVersion = this.catalogData.find(
        (item) => item.id == this.formData.versionId
      ).children;
      //获取当前年级
      this.formData.gradeId = catalogDataVersion.find(
        (item) => item.id == this.formData.volumeId
      ).gradeId;
    },
  },
};
</script>

<style scoped>
>>> .el-select,
.el-cascader {
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/page/audit/components/passAndCatalog.vue